import { PostStaff } from '@/plugins/api'
import moment from 'moment'

function sortObjectsByCreatedAt(objects) {
  return objects.sort((a, b) => {
    const dateA = moment(a.createdAt)
    const dateB = moment(b.createdAt)

    return dateB - dateA
  })
}

export default {
  namespaced: true,
  state: {
    postStaffs: [],
    totalCount: 0,
    notReadCount: 0
  },
  actions: {
    async fetch({ commit }, params) {
      const postStaffs = await PostStaff.fetch(params)
      commit('changeState', { postStaffs })
    },
    async readMore({ state, commit }, params) {
      const postStaffs = await PostStaff.fetch({
        ...params,
        _limit: 10,
        _start: state.postStaffs.length,
        _sort: 'createdAt:DESC'
      })
      commit('changeState', {
        postStaffs: sortObjectsByCreatedAt([...state.postStaffs, ...postStaffs])
      })
    },

    async count({ commit }, params) {
      const totalCount = await PostStaff.count(params)
      commit('changeState', { totalCount })
    },
    async countNotRead({ commit }, params) {
      const notReadCount = await PostStaff.count({ ...params, isRead: 'false' })
      commit('changeState', { notReadCount })
    },
    async updateMany({ commit }, params) {
      await PostStaff.updateMany(params)
    },
    async update({ commit }, { id, ...params }) {
      await PostStaff.update(id, params)
    }
  },
  mutations: {
    setState(state, { key, value }) {
      state[key] = value
    },
    addNotificationRealTime(state, payload) {
      state.postStaffs = sortObjectsByCreatedAt([...state.postStaffs, payload])
      state.notReadCount++
    }
  }
}
